import {TAB_SHOW} from '../../../../common/tabs/tabs.constants';
import {TYPES, TYPES as SETTINGS_TYPES} from '../settings-action-type.constants';
import {TYPES as ACC_TYPES} from "../../accreditation-action-type.constants";
import {IDS} from '../settings-action-id.constants';
import * as Actions from './slo-required-docs.actions';
import * as AccreditationActions from '../../accreditation.actions';
import * as RequirementsActions from '../requirements/requirements.actions';
import * as SettingsActions from '../settings.actions';
import watch from "redux-watch";
import get from "lodash/get";
import {GRID_FILTER, GRID_FILTER_TOGGLE} from '../../../../common/grid/grid.constants';
import {error} from '../../../../common/utils/util.notifier';

class SloRequiredDocsController {
    constructor($ngRedux, $uiRouterGlobals, $state, $stateParams, $scope, $rootScope, $filter, NavigationService, AuthService, EmployeeService, DocumentManager) {
        this.$ngRedux = $ngRedux;
        this.$uiRouterGlobals = $uiRouterGlobals;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.NavigationService = NavigationService;
        this.AuthService = AuthService;
        this.EmployeeService = EmployeeService;
        this.DocumentManager = DocumentManager;
    }

    $onInit() {
        this.identifier = IDS.accSettings;
        this.schemeCode = this.$stateParams.itemCode;
        const navConfig = this.NavigationService.getConfig(this.$state.$current);
        this.colorName = navConfig.colorName;
        this.icon = navConfig.iconSvg.replace(/(\.\/)/g, '');

        this.unsubscribe = this.$ngRedux.connect(state => {
            const requirementDetails = state.accreditation.accSettings.requirementDetails;
            return {
                schemeId:           state.accreditation.accSettings.frameworkDetails.id,
                headOffice:         state.accreditation.accSettings.sloRequiredDocsGrid.filter.hof_uuid,
                gridFilter:         state.accreditation.accSettings.sloRequiredDocsGrid.filter,
                sectionsTree:       state.accreditation.simpleSectionsTree,

                sectionSchemeCode: requirementDetails?.schemeCode,
                sectionId:         requirementDetails?.id,
                sectionParentId:   requirementDetails?.sectionParentId,
                title:              requirementDetails?.nodeName || this.schemeName,
            };
        }, {
            ...AccreditationActions,
            ...RequirementsActions,
            ...SettingsActions,
            ...Actions
        })(this);

        const ctrl = this;
        const user = this.AuthService.getUser();
        if(user.parentCount !== 1){
            ctrl.fetchFrameworkRequirementsTree(ctrl.schemeCode).then(()=>{
                ctrl.initSectionsInputSelects({});
            })
        }
        else{
            this.EmployeeService.getEmploymentLocations(user.uuid).then(siteLocations => {
                const siteLocation = get(siteLocations,'[0].uuid');
                this.$stateParams.slo = siteLocation;
                this.$ngRedux.dispatch({
                    type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        siteLocation,
                    }
                });
                ctrl.fetchFrameworkRequirementsTree(ctrl.schemeCode, siteLocation).then(()=>{
                    ctrl.initSectionsInputSelects({});
                })
            });
        }

        this.getRegulatoryFrameworkDetails(this.schemeCode).then(scheme => {
            this.schemeName = scheme.name;
            this.fetchEnabledHeadOffices(scheme.id);
        })
    }

    initSectionsInputSelects({deselectAll}) {
        // insert requirements to first requirement select box
        this.$ngRedux.dispatch({
            type: SETTINGS_TYPES.SELECT_CASCADE_SECTIONS,
            id: IDS.accSettings,
            level:0,
            sections: this.sectionsTree,
            sectionId: null,
            sectionParentId: null,
        });

        let level2hasChildren = true;
        let selectedLevel1Id, selectedLevel2Id, selectedLevel3Id;
        if(this.sectionId && this.sectionParentId && this.sectionSchemeCode === this.schemeCode){
            const section2 = this.findChildSectionById(this.sectionParentId, this.sectionsTree);
            selectedLevel1Id = section2.sectionParentId;
            selectedLevel2Id = this.sectionParentId;
            selectedLevel3Id = this.sectionId;
        }
        else{
            selectedLevel1Id = get(this.sectionsTree,'[0].id');
            selectedLevel2Id = get(this.sectionsTree,'[0].children[0].id');
            selectedLevel3Id = get(this.sectionsTree,'[0].children[0].children[0].id');
            level2hasChildren = !!get(this.sectionsTree,'[0].children[0].children[0]');
        }

        if(selectedLevel1Id) this.onSelectRequirement({item:{value: selectedLevel1Id}, skipGridFetch: true, deselectAll});
        if(selectedLevel2Id) this.onSelectRequirement({item:{value: selectedLevel2Id}, skipGridFetch: level2hasChildren && !!deselectAll, deselectAll});
        let level3Section;
        if(selectedLevel3Id)
            level3Section = this.onSelectRequirement({item:{value: selectedLevel3Id}, skipGridFetch: !!deselectAll, deselectAll});

        if(level3Section && deselectAll === false){
            this.getFrameworkRequirementDetails({
                ...level3Section,
                schemeCode: this.schemeCode
            });
        }
        if(deselectAll)
            this.$ngRedux.dispatch({
                type:   SETTINGS_TYPES.SELECT_CASCADE_SECTIONS_RESET,
                id:     IDS.accSettings,
            });
    }

    onSelectRequirement({item, skipGridFetch = undefined, deselectAll = false}){
        if(!item) return;
        const section = this.findChildSectionById(item.value, this.sectionsTree);
        const level3Requirements = section.level === 1 && section.children.length
            ? this.findChildSectionById(section.children[0].id, this.sectionsTree).children
            : undefined;
        this.$ngRedux.dispatch({
            type:       SETTINGS_TYPES.SELECT_CASCADE_SECTIONS,
            id:         IDS.accSettings,
            sectionId: section.id,
            level:      section.level,
            sections:  section.children,
            level3Requirements,
            schemeCode: this.schemeCode
        });

        const level3Section =
            level3Requirements?.length && level3Requirements[0]
            || section.children?.length && section.children[0]
            || section;

        if(deselectAll === false) {
            this.$ngRedux.dispatch({
                type: TYPES.REQUIREMENT_DETAILS_REFRESH,
                id: IDS.accreditationSettingsRequirementDetails,
                data: {
                    id: level3Section.id,
                    sectionParentId: level3Section.sectionParentId,
                    level: level3Section.level,
                    nodeName: level3Section.name,
                    prefix: level3Section.number,
                    siblings: level3Section.children.map(item => parseInt(item.numberRaw.split('.').pop())),
                    schemeCode: level3Section.schemeCode,
                }
            });
        }

        this.$ngRedux.dispatch({
            type: skipGridFetch ? GRID_FILTER_TOGGLE : GRID_FILTER,
            id: IDS.accSettings,
            path: IDS.sloRequiredDocsGrid,
            filter: {
                requirement_id: level3Section.id,
                scheme_code: this.schemeCode
            }
        });
        return level3Section
    }

    findChildSectionById(id, sections) {
        return sections.reduce((result, item) => {
            if(result)
                return result;
            if(item.id === id)
                return item
            else if (item.children.length)
                return this.findChildSectionById(id, item.children)
        }, null);
    }

    onSelectHeadOffice({item}){
        this.fetchEnabledSiteLocations(this.schemeId, item.value);
    }

    onResetSloFilterButton(){
        this.initSectionsInputSelects({deselectAll: true});
        this.$ngRedux.dispatch({
            type: TYPES.SLO_DOCS_LOCATION_SELECTS_RESET,
            id: IDS.sloRequiredDocs,
        });
        this.$ngRedux.dispatch({
            type:   GRID_FILTER,
            id:     IDS.accSettings,
            path:   IDS.sloRequiredDocsGrid,
            filter: {
                hof_uuid: null,
                loc_uuid: null,
                requirement_id: null
            }
        });
    }

    onSelect({item}) {
        this.$ngRedux.dispatch({
            type:   SETTINGS_TYPES.SLO_DOC_DETAILS_REFRESH,
            id:     IDS.accSettings,
            data:  {
                ...item,
                schemeId: this.schemeId,
            }
        });
        this.$ngRedux.dispatch({
            type: GRID_FILTER,
            id: IDS.accSettings,
            path: IDS.sloRequiredDocSectionsGrid,
            filter: {
                ard_id: item.ard_id
            }
        });
        this.$ngRedux.dispatch({
            type: TAB_SHOW,
            id: IDS.app_accreditation_scheme_settings_slo_required_docs,
            state: IDS.app_accreditation_scheme_settings_slo_required_docs_details,
        });
    };

    onRemove({item}) {
        this.invalidateEvidenceGroup(item.ard_id, IDS.sloRequiredDocsGrid);
    };

    onDownloadButton({item}){
        this.DocumentManager.downloadFile(item.sample_doc_uri);
    }

    onButtonAdd(event) {
        // if no section selected throw notification
        if(!this.sectionId){
            error('Please select a section first');
            return;
        }
        this.$ngRedux.dispatch({
            type: TYPES.SLO_DOC_DETAILS_RESET,
            id: IDS.accSettings,
        });
        this.$ngRedux.dispatch({
            type: TAB_SHOW,
            id:     IDS.app_accreditation_scheme_settings_slo_required_docs,
            state:  IDS.app_accreditation_scheme_settings_slo_required_docs_add,
        });
    };

    onButtonExport() {
        this.exportSloRequiredDocs(this.gridFilter, this.DocumentManager.downloadFile);
    }

    onButtonImport() {
        return this.$ngRedux.dispatch({
            type: TAB_SHOW,
            id: IDS.app_accreditation_scheme_settings_slo_required_docs,
            state: [IDS.app_accreditation_scheme_settings_slo_required_docs_imports]
        })
    }

    $onDestroy() {
        this.unsubscribe();
        // if(this.unsubscribeWatch)
        //     this.unsubscribeWatch();
    }
}

SloRequiredDocsController.$inject = ['$ngRedux', '$uiRouterGlobals', '$state', '$stateParams', '$scope', '$rootScope', '$filter', 'NavigationService', 'AuthService','EmployeeService','DocumentManager']

export const sloRequiredDocs = {
    controller: SloRequiredDocsController,
    template: `
        <tabs-header title="{{$ctrl.title}}" icon="{{$ctrl.icon}}" color-name="{{$ctrl.colorName}}"></tabs-header>
        <form name="selectCascadeSectionsForm" novalidate layout="row" style="margin-top: 20px">
            <div layout="column" flex>
                <div layout-gt-xs="row" flex>
                    <input-select flex label="{{ 'ACCREDITATION.COMMON.REQUIREMENT' | translate}}"
                                  identifier="{{$ctrl.identifier}}"
                                  state-path="selectCascadeSections.level1RequirementId"
                                  state-data="selectCascadeSections.level1Requirements"
                                  on-change="$ctrl.onSelectRequirement($event)"
                                  select-first-item="true">
                    </input-select>
                    <input-select flex label="{{ 'ACCREDITATION.COMMON.REQUIREMENT' | translate}}"
                                  identifier="{{$ctrl.identifier}}"
                                  state-path="selectCascadeSections.level2RequirementId"
                                  state-data="selectCascadeSections.level2Requirements"
                                  on-change="$ctrl.onSelectRequirement($event)"
                                  select-first-item="true">
                    </input-select>
                    <input-select flex label="{{ 'ACCREDITATION.COMMON.REQUIREMENT' | translate}}"
                                  identifier="{{$ctrl.identifier}}"
                                  state-path="selectCascadeSections.level3RequirementId"
                                  state-data="selectCascadeSections.level3Requirements"
                                  on-change="$ctrl.onSelectRequirement($event)"
                                  select-first-item="true">
                    </input-select>
                </div>
                <div layout-gt-xs="row" layout-align="center center" flex>
                    <div layout-gt-xs="row" flex>
                        <input-select flex
                                      label="{{ 'COMMON.FIELD.HEAD_OFFICE' | translate}}"
                                      identifier="{{$ctrl.identifier}}"
                                      on-change="$ctrl.onSelectHeadOffice($event)"
                                      state-data="sloRequiredDocs.enabledHeadOffices"
                                      state-path="sloRequiredDocsGrid.filter.hof_uuid">
                        </input-select>
                        <input-select flex
                                      label="{{ 'COMMON.FIELD.SITE_LOCATION' | translate}}"
                                      identifier="{{$ctrl.identifier}}"
                                      state-data="sloRequiredDocs.enabledSiteLocations"
                                      state-path="sloRequiredDocsGrid.filter.loc_uuid">
                        </input-select>
                        <input-text flex name="keyword"
                                    label="Document Name"
                                    identifier="{{$ctrl.identifier}}"
                                    state-path="sloRequiredDocsGrid.filter.keyword">
                        </input-text>
                    </div>
                    <button class="btnDefault" ng-click="$ctrl.onResetSloFilterButton()">{{'COMMON.BUTTON.RESET_FILTER' | translate}}</button>
                </div>
            </div>
        </form>

        <slo-required-docs-grid
                on-select="$ctrl.onSelect($event)"
                on-remove="$ctrl.onRemove($event)"
                on-download="$ctrl.onDownloadButton($event)">
        </slo-required-docs-grid>

        <div layout-xs="column" layout-gt-xs="row" layout-align="center center" class="tabs">
<!--            <md-button class="btnDefault" ng-click="$ctrl.onButtonExport()">Export</md-button>-->
<!--            <md-button class="btnDefault" ng-click="$ctrl.onButtonImport()">Import</md-button>-->
            <div flex></div>
            <button type="submit" class="md-button btnColor{{$ctrl.colorName}}" ng-click="$ctrl.onButtonAdd()" aria-label="Add Requirement">{{'ACCREDITATION.SETTINGS.SLO_REQUIRED_DOCUMENTS.LIST.ADD_BUTTON' | translate}}</button>
        </div>
`}
